import React, { useState } from "react";
import { Link } from "react-router-dom";
import RegisteredFamilyChart from "./RegisteredFamilyChart";
import FamilyStatusChart from "./FamilyStatusChart";
import FamilyExpenseChart from "./FamilyExpenseChart";
import FamilyMap from "./FamilyMap";
import { FiRefreshCcw } from "react-icons/fi";

export const FamilyDashboard = () => {
  const [refreshing, setRefreshing] = useState(false);
  const handleRefresh = () => {};
  return (
    <>
      <section className="Admindashboard__task__wrapper ">
        <div className="container">
          <div className="mb-5">
            <div className="grid grid-cols md:grid-cols-2 md:gap-6 gap-4 mt-6 md:mt-4 w-full">
              <FamilyExpenseChart/>
             <FamilyStatusChart/>
            </div>
          <RegisteredFamilyChart/>
          </div>
          <div className="row mb-5">
            <div className="col-md-12 md:mt-6 mt-4 bg-white rounded-xl shadow sm:p-5 p-2.5">
              <div className="dashboardCard">
                <div className="">
                  <p
                    className="mb-2"
                    style={{ color: "black", fontSize: "20px" }}
                  >
                    Registered Family Map
                  </p>
                  <FamilyMap />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
